import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import { GREEN } from '../config/colors';

import { useIsDesktop } from '../hooks/useIsDesktop';
import { useIsMobile } from '../hooks/useIsMobile';
import { InformationDialog } from './dialogs/dialog';

import Info from './icons/Information';

function TooltipInfoIcon({tooltip, className}) {
    const [toggled, setToggled] = useState(false);

    const isMobile = useIsMobile();
    const isDesktop = useIsDesktop();

    const onMouseOver = useCallback(() => {
        if (isDesktop) {
            setToggled(true);
        }
    }, [isDesktop]);

    const onMouseOut = useCallback(() => {
        if (isDesktop) {
            setToggled(false);
        }
    }, [isDesktop]);

    const onClick = useCallback((e) => {
        e.stopPropagation();

        if (isMobile) {
            setToggled(true);
        }
    }, [isMobile, setToggled]);

    const onClose = useCallback((e) => {
        e.stopPropagation();

        setToggled(false);
    }, [setToggled]);

    return (
        <Wrapper
            onClick={onClick}
            onMouseEnter={onMouseOver}
            onMouseLeave={onMouseOut}
        >
            {isMobile &&
                <InformationDialog
                    visible={toggled}
                    onClose={onClose}
                    dismissable={false}
                >
                    <DialogText>{tooltip}</DialogText>
                    <ButtonWrapper>
                        <ButtonClose onClick={onClose}>
                            Stäng
                        </ButtonClose>
                    </ButtonWrapper>
                </InformationDialog>
            }

            {isDesktop &&
                <Tooltip visible={toggled}>
                    {tooltip}
                </Tooltip>
            }
            <Info className={className} />
        </Wrapper>
    );
}

export default styled(TooltipInfoIcon)``;

const Wrapper = styled.span`
    width: 20px;
    height: 20px;
    position: relative;
    display: inline-block;
    vertical-align: middle;
`;

const Tooltip = styled.span`
    display: block;
    width: 250px;
    white-space: pre-wrap;
    position: absolute;
    left: 50%;
    bottom: 35px;
    transform: translateX(-50%);
    background: white;
    z-index: 10;
    border-radius: 7px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    padding: 15px;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: all 0.2s;
    font-style: italic;
    font-size: 14px;
    line-height: 18px;

    ${props => props.visible && css`
        opacity: 1;
        visibility: visible;
        pointer-events: all;
    `}
`;

const ButtonWrapper = styled.div`
    text-align: center;
    margin-top: 30px;
`;

const Button = styled.button`
    border: 2px solid;
    border-radius: 7px;
    background: white;
    font-family: "adelle", serif;
    font-style: italic;
    font-weight: bold;
    cursor: pointer;
    padding: 25px;
    font-size: 20px;
    line-height: 16px;
`;

const ButtonClose = styled(Button)`
    color: ${GREEN};
`;

const DialogText = styled.p`
    font-size: 16px;
    text-align: center;
`;
